// extracted by mini-css-extract-plugin
export default {"testimonial_section":"Testimonial_testimonial_section__FTA4z","section":"Testimonial_section__IDM5I","carousel":"Testimonial_carousel__BzdPF"};